<template>
  <div class="order-grid col-sm-12 col-md-12 col-lg-12">
    <div class="header2">
      <h1 class="title">Current Procedures</h1>
      <button type="button" @click="showAddProc">
        <font-awesome-icon icon="plus-circle" />
      </button>
    </div>
    <form :id="'procmodal'+patient.id" @submit.prevent="saveProc" class="diagnosismodal col-sm-12 col-md-12 col-lg-12">
                <!-- <section class="modalclose">
                  <a href="#close" title="close Modal" id="amodalclose">X</a>
                </section> -->
                <div class="modaltop">
                  <section class="diagtitlesec col-sm-12 col-md-6 col-lg-6">
                    <h3>Procedure</h3>
                  </section>
                </div>
                <div class="modalbottom">
                  <!-- <div id="diagnostypeSec">
                    <label>Type:</label> <br />
                    <label>
                      <input type="checkbox" id="diagchkbox" />Diagnosis</label
                    ><br />
                    <label
                      ><input
                        type="checkbox"
                        id="procedurechkbox"
                      />Proceedure</label
                    >
                  </div> -->
                  <div class="icd10second col-sm-12 col-lg-12">
                    <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>Procedure Description</label>
                      <!-- <label id="srchbylbl">{{icdSearch ? "Search By ICD-10 Description" : "Search By ICD-10 Code"}}</label
                      ><label id="switch"
                        ><input type="checkbox" id="toggleSearch" v-model="icdSearch"/></label> -->
                        <br />
                      <input
                        required
                        name="procCode"
                        type="text"
                        id="srchnlookupterms"
                        title="cpt proc field"
                        v-model="procSearchDescrip"
                        placeholder='Type in your CPT description'
                        @keyup.prevent="showProcSearch"
                      />
                      <!-- <a href="#searchicon"
                        ><img
                          src="https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-ios7-search-512.png"
                          width="20"
                          height="20"
                      /></a> -->
                    </div>
                    <div id="icdsectopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>ICD-10 Description</label>
                      <!-- <label id="srchbylbl">{{icdSearch ? "Search By ICD-10 Description" : "Search By ICD-10 Code"}}</label
                      ><label id="switch"
                        ><input type="checkbox" id="toggleSearch" v-model="icdSearch"/></label> -->
                        <br />
                      <input
                        required
                        name="icdCode"
                        type="text"
                        id="srchnlookupterms"
                        title="icd-10 diagnosis field"
                        v-model="diagSearchDescrip"
                        :placeholder="icdSearch ? 'Type in your ICD code or a description' : 'Type in your ICD Code'"
                        @keyup.prevent="showDiagSearch"
                      />
                    </div>
                    <div id="icdthirdopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>Date *</label><br />
                      <input type="date" id="diagnosisDate" required name="date"/>
                    </div>
                    <div id="icdfourthopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>System Control Rating </label><br />
                      <input type="number" id="controlnumber" min="0" max="4" name="syscontrol"/>
                    </div>
                  </div>
                  <div class="icd10fourth col-sm-12 col-lg-12">
                    <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>Instruction</label>
                      <textarea id="instruction" name="instruction" cols=100 type="text"/>
                    </div>
                  </div>
                  <div class="icd10thrid col-sm-12 col-lg-12">
                    <ul class="list">
                      <span v-if="searchedProcs.length > 0">Procedures</span>
                      <span v-if="searchedDiags.length > 0">Diagnosis</span>

                      <li v-if="activeSearch==='procedure'" v-for="(procedure, index) in paginatedData" :key="index" class="list__item">
                        <a class="list__link" @click="clickProc(procedure)">
                          {{ index + 1 }}. {{ procedure.description }}
                        </a>
                      </li>
                      <li v-if="activeSearch==='diagnosis'" v-for="(diagnosis, index) in paginatedData" :key="index" class="list__item">
                        <a class="list__link" @click="clickDiag(diagnosis)">
                          {{ index + 1 }}. {{ diagnosis.description }}
                        </a>
                      </li>


                    </ul>
                    <div v-if="searchedProcs.length > 0">
                      <button :disabled="pageNumber === 0" @click="prevPage" class="btn btn-prev">
                        Previous
                      </button>

                      <input type="text" v-model="currPageNumber" id="currentPageNumber" style="width: 30px" />
                      <label for="currentPageNumber">/{{ pageCount() }} <button @click="toPage(currPageNumber - 1)"
                          class="btn ml-2">Go</button></label>

                      <button :disabled="pageNumber >= (pageCount() - 1)" @click="nextPage" class="btn btn-next">
                        Next
                      </button>
                    </div>


                    <div v-if="searchedDiags.length > 0">
                      <button :disabled="pageNumber === 0" @click="prevPage" class="btn btn-prev">
                        Previous
                      </button>

                      <input type="text" v-model="currPageNumber" id="currentPageNumber" style="width: 30px" />
                      <label for="currentPageNumber">/{{ pageCount() }} <button @click="toPage(currPageNumber - 1)"
                          class="btn ml-2">Go</button></label>

                      <button :disabled="pageNumber >= (pageCount() - 1)" @click="nextPage" class="btn btn-next">
                        Next
                      </button>
                    </div>



                  </div>
                  <div class="icd10fifth col-sm-12 col-lg-12">
                    <div id="icdsfrthopt" class="col-sm-12 col-md-12 col-lg-12">
                      <input type="submit" id="savediagnbtn" value="Save"/>
                      <input type="button" id="canceldiagbtn" value="Cancel" @click="closeProc"/>
                    </div>
                  </div>
                </div>
                <!--end Order Grid for Modal-->
              </form>

	<div class="order-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columnrow">
                  <!--Start Colum-->
                  <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                  >
                    <span id="row" class="coltext">Order ID</span>
                  </div>
                  <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                  >
                    <span id="row" class="coltext">Procedure</span>
                  </div>
                  <!-- <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                  >
                    <span id="col4" class="coltext">Diagnosis Type</span>
                  </div> -->
                  <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                  >
                    <span id="row" class="coltext">Diagnosis</span>
                  </div>
                  <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                  >
                    <span id="row" class="coltext">Instruction</span>
                  </div>
                  <!-- <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                  >
                    <span id="col6" class="coltext">Onset/Exacerbation</span>
                  </div> -->
                  <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                  >
                    <span id="row" class="coltext">Date</span>
                  </div>
                  <!-- <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                  >
                    <span id="col8" class="coltext">Alternative Route</span>
                  </div> -->
                </div>
                <!--end Column top-->
                <template v-if="allProcs">
                  <div v-for="(proc, index) in allProcs.slice().reverse()" :key="'diag'+index" class="columnrow">
                    <!--start column row-->
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                    >
                      <span id="row" class="coltext">{{proc.order_id}}</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                    >
                      <span id="row" class="coltext">{{proc.procedure_code}}</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                    >
                      <span id="row" class="coltext">{{proc.diagnosis_code}}</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                    >
                      <span id="row" class="coltext">{{proc.instruction}}</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row"
                    >
                      <span id="row" class="coltext">{{proc.diagnosis_date ? proc.diagnosis_date : '—'}} to<br/> {{ proc.end_date ? proc.end_date : '—' }}</span>
                    </div>
                    <!-- <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                    >
                      <span id="row" class="coltext">12 mil</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                    >
                      <span id="row" class="coltext msgiconbtn">33 liters</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                    >
                      <span id="row" class="coltext">Pending</span>
                    </div> -->
                  </div>
                </template>
				</div>
      </div>
</template>
<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
  name: "CurrentProc",
  data() {
    return {
      icdSearch: true,
      diagSearchCode: "", // ICD-10 search code value
      diagSearchDescrip: "", // ICD-10 search description (textfield) value
      searchedDiags: [], // List of ICD codes retrieved via icdSearch

      showProc: false,              // Checkbox that activates Procedure tab
      allProcs: null,               // List of procedures already saved for patient
      procSearchDescrip: "",        // CPT search descriptions (textfield) value
      searchedProcs: [],            // List of CPT codes retrieved via procSearch
      pageNumber: 0,
      size: 5,
      currPageNumber: 1,
      paginatedData: [],
      activeSearch: ""
    };
  },
  async mounted() {
    this.loadProcedures();
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function() {
      return this.allData.patient;
    },
  },
  methods: {
    pageCount() {
      let l;
      if(this.activeSearch === 'procedure')
        l = this.searchedProcs.length;
      if(this.activeSearch === 'diagnosis')
        l = this.searchedDiags.length;
      let x =  Math.ceil(l / this.size);
      return x;
    },
    paginateData() {
      let start = this.pageNumber * this.size, end = start + this.size;
      if(this.activeSearch === 'procedure')
        this.paginatedData = this.searchedProcs.slice(start, end);
      else if(this.activeSearch === 'diagnosis')
      {
        this.paginatedData = this.searchedDiags.slice(start, end);
      }
    },
    nextPage() {
      this.pageNumber++;
      this.currPageNumber = this.pageNumber + 1;
      this.paginateData()
    },
    prevPage() {
      this.pageNumber--;
      this.currPageNumber = this.pageNumber + 1;
      this.paginateData()
    },
    toPage(pageNumber) {
      this.pageNumber = pageNumber;
      this.paginateData()
    },
    async loadProcedures() {
      let content = {
        Diagnosis: {
          API_Meth: "PopulateDiagGrid",
          patientID: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.gridhtml) {
            this.allProcs = res.data.data.filter(
              (proc) => proc.diagnosis_type === "Procedure"
            );
          } else {
            this.allProcs = null;
          }
        });
    },
    
    async saveProc() {
      let form = document.getElementById("procmodal"+this.patient.id)
      let content = {
        "Diagnosis": {
          "API_Meth": "InsertDiagnosis",
          "ordernumber": 0,
          "diagnosis_type": "Procedure",
          "onset_exacerbation": "",
          "diagnosisDate": form.elements['date'].value,
          "diagControlRating": form.elements['syscontrol'].value,
          "diagcode": form.elements['icdCode'].value,
          "proccode": form.elements['procCode'].value,
          "pid": this.patient.externId,
          "status": "Active",
          "instruction": form.elements['instruction'].value,
          "writer": this.allData.manager.name
        }
      }
      await axios.post(CURR_API + "/tswebhook.php", content, {headers: {'Content-Type': 'application/json;'}})
      .then((res) => {
        if (res.data.result && res.data.result == "Inserted") {
          this.diagSearchCode = ''
          this.diagSearchDescrip = ''
          this.procSearchDescrip = ''
          this.loadProcedures()
          alert("Procedure successfully added")
          form.style.display = "none"
          form.reset()
        }
        else {
          alert("Error with procedure insertion. Try again or contact an administrator.")
        }
      })
    },
    async showProcSearch() {
      this.activeSearch = 'procedure';
      this.searchedProcs = []
      this.searchedDiags = [];
      this.paginatedData = []
      if (this.procSearchDescrip == "") {
        this.searchedProcs = []
        this.searchDiags = [];
        this.paginatedData = []
        return
      }
      if (!isNaN(this.procSearchDescrip)) {
        let content = {
          "Diagnosis": {
            "API_Meth": "SearchProcedure-Code",
            "searchterms": this.procSearchDescrip
          }
        }
        await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
          .then((res) => {
            if (res.data.result && res.data.result != "No Data Found") {
              this.searchedProcs = res.data.result
            }
            else {
              this.searchedProcs = []
            }
          })
      }
      else {
        let content = {
          "Diagnosis": {
            "API_Meth": "SearchProcedure-Description",
            "description": this.procSearchDescrip
          }
        }
        await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
          .then((res) => {
            if (res.data.count) {
              if (res.data.result.msg) {
                alert("Error:" + res.data.result.msg)
              }
              else {
                this.searchedProcs = res.data.result
                this.currPageNumber = 1
                this.pageNumber = 0
                this.paginateData()
              }
            }
            else {
              this.searchedProcs = []
              this.paginatedData = []
            }
          })
      }
    },
    async showDiagSearch() {

      this.activeSearch = 'diagnosis'
      this.searchedProcs = [];
      this.searchedDiags = [];
      this.paginatedData = [];

      if (this.diagSearchDescrip == "") {
        this.searchedProcs = []
        this.searchedDiags = [];
        this.paginatedData = []
        return
      }
      if (true) {
        let content = {
          action: "Search",
          searchTerm: this.diagSearchDescrip,
          ICDCode: "",
          ICDReleaseUrl: "",
        };
        await axios
          .post(CURR_API + "/icd_calls.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.result == 0) {
              this.searchedDiags = [];
            } else {
              this.searchedDiags = res.data.actualResults;
              this.currPageNumber = 1;
              this.pageNumber = 0;
              this.paginateData();
            }
          });
      }
      // else {
      //   let content = {
      //     "action": "CodeLookUp",
      //     "searchTerm": "",
      //     "ICDCode":
      //   }
      // }
    },
    clickDiag(diag) {
      this.diagSearchCode = diag.code;
      this.diagSearchDescrip = diag.code + " - " + diag.description;
      this.searchedDiags = [];
    },
    clickProc(proc) {
      this.procSearchDescrip = proc.code + ' - ' + proc.description
      this.searchedProcs = []
    },
    showAddProc() {
      $("#procmodal"+this.patient.id).css("display","block");
    },
    closeProc() {
      let form = document.getElementById('procmodal' + this.patient.id)
      form.reset()
      form.style.display = "none"
    },
  },
};
</script>
<style scoped lang="scss">
.header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #0060ff;
}
.title {
  margin-right: 20px;
}
</style>
